import type { Questionnaire } from '@medplum/fhirtypes'

export const checkInQuestionnaire = {
  resourceType: 'Questionnaire',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/check-in',
  id: 'ops-check-in',
  status: 'active',
  subjectType: ['Patient'],
  name: 'Check In',
  title: 'Participant Check In',
  item: [
    {
      linkId: 'participant',
      text: 'Participant',
      type: 'reference',
      required: true,
      extension: [
        {
          url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-referenceResource',
          valueCodeableConcept: {
            coding: [
              {
                code: 'Patient',
              },
            ],
          },
        },
      ],
    },
    {
      linkId: 'badge',
      text: 'Assign Badge',
      type: 'choice',
      required: true,
      answerOption: [
        {
          valueCoding: {
            code: 'SGV-BADGE-1',
            display: 'Badge 1',
            system:
              'https://www.seenhealth.org/fhir/CodeSystem/wanderguard-devices',
          },
        },
        {
          valueCoding: {
            code: 'SGV-BADGE-2',
            display: 'Badge 2',
            system:
              'https://www.seenhealth.org/fhir/CodeSystem/wanderguard-devices',
          },
        },
        {
          valueCoding: {
            code: 'SGV-BADGE-3',
            display: 'Badge 3',
            system:
              'https://www.seenhealth.org/fhir/CodeSystem/wanderguard-devices',
          },
        },
        {
          valueCoding: {
            code: 'SGV-BADGE-4',
            display: 'Badge 4',
            system:
              'https://www.seenhealth.org/fhir/CodeSystem/wanderguard-devices',
          },
        },
        {
          valueCoding: {
            code: 'SGV-BADGE-5',
            display: 'Badge 5',
            system:
              'https://www.seenhealth.org/fhir/CodeSystem/wanderguard-devices',
          },
        },
        {
          valueCoding: {
            code: 'SGV-WATCH-1',
            display: 'Watch 1',
            system:
              'https://www.seenhealth.org/fhir/CodeSystem/wanderguard-devices',
          },
        },
        {
          valueCoding: {
            code: 'SGV-WATCH-2',
            display: 'Watch 2',
            system:
              'https://www.seenhealth.org/fhir/CodeSystem/wanderguard-devices',
          },
        },
        {
          valueCoding: {
            code: 'SGV-WATCH-3',
            display: 'Watch 3',
            system:
              'https://www.seenhealth.org/fhir/CodeSystem/wanderguard-devices',
          },
        },
        {
          valueCoding: {
            code: 'SGV-WATCH-4',
            display: 'Watch 4',
            system:
              'https://www.seenhealth.org/fhir/CodeSystem/wanderguard-devices',
          },
        },
        {
          valueCoding: {
            code: 'SGV-WATCH-5',
            display: 'Watch 5',
            system:
              'https://www.seenhealth.org/fhir/CodeSystem/wanderguard-devices',
          },
        },
      ],
    },
    {
      linkId: 'notes',
      text: 'Check-in Notes',
      type: 'text',
      required: false,
    },
  ] as const,
} satisfies Questionnaire
